import { DeleteOutlined } from "@ant-design/icons";
import { Checkbox, Button, Image, Input } from "antd";
import { useCart } from "contexts/CartContext";
import { useState } from "react";
import "./CartItem.scss";
import { useUnit } from "contexts/UnitContext";
import Helpers from "@utils/Helpers";
import Validates from "@utils/Validates";
import { useNavigate } from "react-router-dom";
interface ICartitem {
  data: any;
  productSelected: any;
  setProductSelected: (selecteds: any) => void;
  type: "checkout" | "cart";
}
let updateTimer: any;

const CartItem: React.FC<ICartitem> = ({
  data,
  productSelected,
  setProductSelected,
  type,
}) => {
  const { units, convertCurrency } = useUnit();
  const { removeItem, updateQuantity, userCart, setUserCart } = useCart();
  const [bundleQuantity, setBundleQuantity] = useState(1);
  const navigate = useNavigate();

  // CALCULATE PRICE
  const calculatePrice = () => {
    let total = 0;
    if (data.unit == "Ton") {
      total =
        data.quantity *
        (data.bale_weight / 1000) *
        convertCurrency(
          data.discounted_price ? data.discounted_price : data.price_per_tons,
          "USD",
          units.currency
        );
    } else {
      total =
        data.quantity *
        convertCurrency(
          data.discounted_price ? data.discounted_price : data.price_per_bale,
          "USD",
          units.currency
        );
    }
    return Helpers.formatNumber(total, 2);
  };

  // REMOVE ITEM
  const removeCartItem = (productId: number) => {
    const payload = {
      product_id: productId,
    };
    removeItem(payload);
  };

  // HANDLE CHECK
  const handleCheckItem = (isChecked: boolean) => {
    const updatedItems: any[] = productSelected.map((item: any) =>
      item.productId === data.product_id
        ? { ...item, isSelected: isChecked ? true : false }
        : item
    );
    setProductSelected(updatedItems);
  };

  // HANDLE UPDATE QUANTITY
  const handleUpdateQuantity = (value: any) => {
    if (value === "") {
      value = "";
    }
    if (Number(value) <= 0) {
      value = 1;
    }
    if (Number(value) > data.total_quantity) {
      value = data.total_quantity;
    }

    value = value.toString();
    let quantityInput: any = Validates.validateNumberForm(value);
    quantityInput = Number(quantityInput);

    const updatedItems = userCart.map((item) =>
      item.product_id === data.product_id
        ? { ...item, quantity: quantityInput }
        : item
    );

    setUserCart(updatedItems);

    const payload = {
      product_id: data.product_id,
      quantity: quantityInput,
    };

    clearTimeout(updateTimer);
    updateTimer = setTimeout(() => {
      updateQuantity(payload);
    }, 500);
  };

  return (
    <div className="CartItem">
      {type === "cart" && (
        <Checkbox
          checked={(() => {
            const filtered = productSelected.find(
              (item: any) => item.productId === data.product_id
            );
            return filtered ? filtered.isSelected : false;
          })()}
          onChange={(e) => handleCheckItem(e.target.checked)}
        />
      )}
      <Image
        className="product-image"
        src={data.image}
        width={100}
        height={100}
        preview={false}
      />
      {type === "cart" && (
        <>
          <div className="product-info-cart">
            <div
              className="product-name"
              onClick={() => {
                navigate("/product/detail?productId=" + data.product_id);
              }}
            >
              {data.hay_type}
            </div>
            <div className="product-quantity">
              <div className="label">Quantity:</div>
              <span>
                <Input
                  className="quantity-input"
                  variant="filled"
                  value={data.quantity}
                  max={data.total_quantity}
                  min={1}
                  onChange={(e: any) => handleUpdateQuantity(e.target.value)}
                />
                <span className="small text-muted ms-3">
                  (in stock: {data.total_quantity} bales)
                </span>
              </span>
            </div>

            <div className="product-quantity-control">
              <div className="quantity-control">
                <div className="control-buttons">
                  <Button
                    className="increase-btn"
                    onClick={() =>
                      handleUpdateQuantity(data.quantity + bundleQuantity)
                    }
                  >
                    +
                  </Button>
                  <Button
                    className="decrease-btn"
                    onClick={() =>
                      handleUpdateQuantity(data.quantity - bundleQuantity)
                    }
                  >
                    -
                  </Button>
                </div>
                <div
                  className={`control-value ${
                    bundleQuantity === 1 ? "selected" : ""
                  }`}
                  onClick={() => setBundleQuantity(1)}
                >
                  1
                </div>
                <div
                  className={`control-value ${
                    bundleQuantity === 10 ? "selected" : ""
                  }`}
                  onClick={() => setBundleQuantity(10)}
                >
                  10
                </div>
                <div
                  className={`control-value ${
                    bundleQuantity === 50 ? "selected" : ""
                  }`}
                  onClick={() => setBundleQuantity(50)}
                >
                  50
                </div>
                <div
                  className={`control-value ${
                    bundleQuantity === 100 ? "selected" : ""
                  }`}
                  onClick={() => setBundleQuantity(100)}
                >
                  100
                </div>
              </div>
              <Button
                icon={<DeleteOutlined />}
                size="small"
                variant="filled"
                className="clear-item-btn"
                onClick={() => removeCartItem(data.product_id)}
              />
            </div>
          </div>
          <div className="product-type-price">
            <div className="product-type">Hay</div>
            <div className="product-price">
              $
              {Helpers.formatNumber(
                convertCurrency(
                  data.discounted_price
                    ? data.discounted_price
                    : data.unit == "Ton"
                    ? data.price_per_tons
                    : data.price_per_bale,
                  "USD",
                  units.currency
                ),
                2
              )}{" "}
              / {data.unit}
              <b>${calculatePrice()}</b>
            </div>
          </div>
        </>
      )}
      {type === "checkout" && (
        <div className="product-info-checkout">
          <div
            className="product-name"
            onClick={() => {
              window.open(
                "/product/detail?productId=" + data.product_id,
                "_blank"
              );
            }}
          >
            {data.hay_type} <div className="product-type">Hay</div>
          </div>

          <div className="quantity-price">
            <div className="product-quantity">
              <div className="label">Quantity:</div>
              <span>{data.quantity} bales</span>
            </div>
            <div className="product-price">
              $
              {Helpers.formatNumber(
                convertCurrency(
                  data.discounted_price
                    ? data.discounted_price
                    : data.unit == "Ton"
                    ? data.price_per_tons
                    : data.price_per_bale,
                  "USD",
                  units.currency
                ),
                2
              )}{" "}
              / {data.unit}
              <b>${calculatePrice()}</b>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CartItem;
